import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { fareharborModalStyles } from "styles/IntegrationDirectory/fareharborModal.styles";

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: { xs: "90%", sm: "500px" },
  width: { xs: "90%", sm: "500px" },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  margin: "0px 0px",
  p: { xs: 1, md: 2 },
};

interface ModalProps {
  open: boolean;
  close: () => void;
}

export default function FHErrorModal({ open, close }: ModalProps) {
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="customer-modal-title"
      aria-describedby="customer-modal-description"
    >
      <Box sx={{ ...style }}>
        <Box sx={fareharborModalStyles.headerContainer}>
          <Typography variant="h6" fontWeight={600}>
            Integration could not be completed
          </Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography
          sx={[fareharborModalStyles.mainText, fareharborModalStyles.mv10]}
        >
          Here is how to troubleshoot:
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "row", gap: "4px" }}>
          <Typography sx={fareharborModalStyles.subBoldText}>
            ✔ Verify
          </Typography>
          <Typography sx={fareharborModalStyles.subText}>
            that your FareHarbor Shortname is correct.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "row", gap: "4px" }}>
          <Typography sx={fareharborModalStyles.subBoldText}>
            ✔ Send the integration request
          </Typography>
          <Typography sx={fareharborModalStyles.subText}>
            if you haven’t already.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "row", gap: "4px" }}>
          <Typography sx={fareharborModalStyles.subBoldText}>
            ✔ Check your inbox
          </Typography>
          <Typography sx={fareharborModalStyles.subText}>
            for FareHarbor’s confirmation email.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "row", gap: "4px" }}>
          <Typography sx={fareharborModalStyles.subBoldText}>
            ✔ Allow up to 24 hours
          </Typography>
          <Typography sx={fareharborModalStyles.subText}>
            for the integration to be approved.
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}
